import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { NgModel } from '@angular/forms';
import { ProcessLog } from '../../../../model/src/lib/process-log.model';

@Component({
  selector: 'sigv-process-logs',
  templateUrl: './process-logs.component.html',
  styleUrls: ['./process-logs.component.scss'],
})
export class ProcessLogsComponent implements OnInit {
  @ViewChild('descriptionTextareaModel')
  descriptionTextareaModel!: NgModel;
  /**
   * 是否為檢視模式, 預設為 false
   */
  @Input() public isViewMode = false;
  /**
   * 處理記錄資料集合, 預設為空陣列
   */
  @Input() public processLogs: ProcessLog[] = [];
  /**
   * 區塊是否需要有 margin bottom, 預設為 true
   */
  @Input() public hasMarginBottom = true;

  /**
   * 描述欄位內容，提供雙向綁定, 預設為空字串
   *
   * Sample: [(description)]="description"
   */
  @Input() description = '';
  @Output() descriptionChange = new EventEmitter<string>();
  /**
   * 描述欄位內容是否為必須填寫
   */
  @Input() public isDescriptionRequired = false;

  isShowDialog = false;

  constructor() {}

  ngOnInit(): void {}

  toggleDialog(event: any): void {
    event?.preventDefault();
    this.isShowDialog = !this.isShowDialog;
  }

  changeDescription(): void {
    this.descriptionChange.emit(this.description);
  }

  marDescriptionAsTouch(): void {
    const descriptionTextareaModel = this.descriptionTextareaModel;
    if (
      typeof descriptionTextareaModel?.control?.markAsTouched === 'function'
    ) {
      descriptionTextareaModel.control.markAsTouched();
    }
  }
}
